import React from 'react'
import PropTypes from 'prop-types'

import NoteCard from '../NoteCard/NoteCard'

import './NoteList.scss'

export default class NoteList extends React.Component {

	static propTypes = {
		notes: PropTypes.array.isRequired
	}

	getNoteNumber(noteIndex) {
		return this.props.notes.length - noteIndex;
	}

	render() {
		const { notes } = this.props;
		return (
			<div className="NoteList">

				{ notes.map((note, i) =>
					<NoteCard key={note._id} noteNumber={this.getNoteNumber(i)} note={note}></NoteCard>
				)}

			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/scenes/Notes/components/NoteList/NoteList.jsx